export default function auth({next, router}) {
    if (!localStorage.getItem('id_token')){
        console.log('auth');
        return router.push({name: 'login'})}
    return next();
}